import { render, staticRenderFns } from "./monthlyStatement.vue?vue&type=template&id=322052c4&scoped=true"
import script from "./monthlyStatement.vue?vue&type=script&lang=js"
export * from "./monthlyStatement.vue?vue&type=script&lang=js"
import style0 from "./monthlyStatement.vue?vue&type=style&index=0&id=322052c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322052c4",
  null
  
)

export default component.exports